import type { KyInterface } from '@gik/core/api/ky/types';
import { wpAcfV3Api } from '../ky/wpApi';
import { makeWPApi } from './useWPApi';

export const useWPAcfV3Api = makeWPApi(wpAcfV3Api as KyInterface);
